import React from 'react';
import type { FormData } from '../utils/formUtils';

interface TodoFormSchedulingProps {
  formData: FormData;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
}

const HORIZON_OPTIONS = [
  { value: 'now', label: 'NOW', color: 'bg-red-100 text-red-800 border-red-300' },
  { value: 'next', label: 'NEXT', color: 'bg-blue-100 text-blue-800 border-blue-300' },
  { value: 'soon', label: 'SOON', color: 'bg-yellow-100 text-yellow-800 border-yellow-300' },
  { value: 'later', label: 'LATER', color: 'bg-gray-100 text-gray-700 border-gray-300' },
  { value: 'someday', label: 'SOMEDAY', color: 'bg-purple-100 text-purple-800 border-purple-300' },
] as const;

const TodoFormScheduling: React.FC<TodoFormSchedulingProps> = ({
  formData,
  setFormData,
}) => {
  const currentHorizon = formData.horizon;

  return (
    <div className="flex items-center gap-2">
      <span className="text-xs font-medium text-gray-600">Horizon:</span>
      <div className="flex items-center gap-1.5">
        {HORIZON_OPTIONS.map(({ value, label, color }) => (
          <button
            key={value}
            type="button"
            onClick={() => setFormData({ ...formData, horizon: value })}
            className={`px-2.5 py-1 text-xs font-medium rounded-full border transition-colors ${
              currentHorizon === value
                ? color
                : 'bg-gray-50 text-gray-600 border-gray-200 hover:bg-gray-100'
            }`}
          >
            {label}
          </button>
        ))}
        {currentHorizon && (
          <button
            type="button"
            onClick={() => setFormData({ ...formData, horizon: '' })}
            className="px-2 py-1 text-xs font-medium text-gray-500 hover:text-gray-700 rounded-full border border-gray-200 hover:bg-gray-100 transition-colors"
            title="Clear horizon"
          >
            Clear
          </button>
        )}
      </div>
    </div>
  );
};

export default TodoFormScheduling;
